export default "__VITE_ASSET__CDke1eaI__"